"use strict";
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SessionTokenStorage = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _TokenSessionStorageKeys = require("../TokenSessionStorageKeys");
var _constants = require("../constants");
var _AuthCookies = require("../internals/AuthCookies");
var _SessionValue = require("./SessionValue");
// Checks if auth cookie value satisfies new cookie value format as previously auth cookie included only date of expiration instead of new tenant\consultant-number format
var isNewAuthCookie = function(cookieValue) {
    return typeof cookieValue === 'string' && /[a-z]{2,}\\\d+/i.test(cookieValue);
};
var SessionTokenStorage = /*#__PURE__*/ function() {
    function SessionTokenStorage() {
        var _this = this;
        var tokenStorageKey = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _TokenSessionStorageKeys.TokenSessionStorageKeys.USER_ACCESS;
        _class_call_check(this, SessionTokenStorage);
        // FIXME: Mark as private!
        (0, _defineProperty2.default)(this, "token", void 0);
        (0, _defineProperty2.default)(this, "tokenStorageKey", void 0);
        /**
     * Returns valid token. If token in session storage is not valid then it is removed and function returns null
     */ (0, _defineProperty2.default)(this, "getToken", function() {
            _this.validateStored();
            return _this.token.get();
        });
        (0, _defineProperty2.default)(this, "setToken", function(tokenData) {
            var newStorageValue = _object_spread({}, tokenData);
            var userValue = newStorageValue.User;
            var shouldUseFallback = !('User' in newStorageValue) || userValue === undefined || userValue === null || userValue === '';
            if (shouldUseFallback) {
                newStorageValue.User = _this.getTokenUser();
            }
            _this.token.set(newStorageValue);
            return _this;
        });
        this.tokenStorageKey = tokenStorageKey;
        this.token = this.createStorageItem();
    }
    _create_class(SessionTokenStorage, [
        {
            /**
   * Returns true is token storage is for user token
   */ key: "isForUserToken",
            value: function isForUserToken() {
                return this.tokenStorageKey === _TokenSessionStorageKeys.TokenSessionStorageKeys.USER_ACCESS;
            }
        },
        {
            /**
   * Gets token user which is stored alongside token in storage.
   * If current instance of storage handles user token then this falls back to value inside cookie.
   * Othervise it falls back to default anonymous value
   */ key: "getTokenUser",
            value: function getTokenUser() {
                var _this_token_get;
                var existingUserInsideToken = (_this_token_get = this.token.get()) === null || _this_token_get === void 0 ? void 0 : _this_token_get.User;
                if (this.isForUserToken()) {
                    var _AuthCookies_AuthCookies_getAuthorizedUserValue;
                    return (_AuthCookies_AuthCookies_getAuthorizedUserValue = _AuthCookies.AuthCookies.getAuthorizedUserValue()) !== null && _AuthCookies_AuthCookies_getAuthorizedUserValue !== void 0 ? _AuthCookies_AuthCookies_getAuthorizedUserValue : existingUserInsideToken;
                }
                return existingUserInsideToken !== null && existingUserInsideToken !== void 0 ? existingUserInsideToken : _constants.PUBLIC_TOKEN_USER;
            }
        },
        {
            /**
   * Check for compatibility between whats stored in cookies and whats stored in token
   * These two should be the same
   * This check should also happen when both properties are set (Cookie and <token-from-storage>.User)
   */ key: "validateStored",
            value: function validateStored() {
                var storedData = this.token.get();
                if (!storedData) {
                    return;
                }
                var cleanStored = false;
                var cookieValue = _AuthCookies.AuthCookies.getAuthorizedUserValue();
                var isUserToken = this.isForUserToken();
                // 1. Checking for presence both cookie and storedData.User is for backward compatibility with older versions of the @ori/auth package that does not set key User into token storage.
                // Or the user is not logged in or cookies are not supported, e.g. in appshell.
                if (isUserToken && (!cookieValue || !storedData.User)) {
                    cleanStored = true;
                } else if (isNewAuthCookie(cookieValue) && isUserToken && cookieValue !== storedData.User) {
                    cleanStored = true;
                } else if (Date.parse(storedData.ExpirationDate) <= Date.now()) {
                    cleanStored = true;
                }
                if (cleanStored) {
                    this.token.remove();
                }
            }
        },
        {
            key: "createStorageItem",
            value: function createStorageItem() {
                return new _SessionValue.SessionValue(this.tokenStorageKey);
            }
        }
    ]);
    return SessionTokenStorage;
}();
exports.SessionTokenStorage = SessionTokenStorage; //# sourceMappingURL=SessionTokenStorage.js.map
